
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.467 9.024a.83.83 0 01-.408.233 3.335 3.335 0 101.686 6.45.833.833 0 01.454 1.604 5 5 0 01-3.006-9.535 5.834 5.834 0 0111.618.041 5.001 5.001 0 01-3.122 9.494.833.833 0 11.455-1.604 3.337 3.337 0 004.244-3.207 3.335 3.335 0 00-2.558-3.243.834.834 0 01-.633-.702.832.832 0 01-.03-.222 4.167 4.167 0 00-8.334 0c0 .288-.145.541-.366.69zM9.41 8.13a.833.833 0 011.177-.003l2.972 2.948a.833.833 0 11-1.174 1.183l-1.552-1.539v5.114a.833.833 0 11-1.666 0v-5.098L7.7 12.205a.833.833 0 11-1.18-1.176L9.41 8.13z"}})])
          )
        }
      }
    